import React from "react"
import { Badge, Card, CardBody, Col, Row } from "reactstrap"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator"
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import { Link } from "react-router-dom"
import { columns } from "./columns"

const { SearchBar } = Search

const CPSRequestsList = ({ entries, myUser }) => {
  const node = React.createRef()

  const pageOptions = {
    sizePerPage: 10,
    totalSize: entries?.length,
    custom: true,
  }

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]

  return (
    <Card>
      <CardBody>
        <PaginationProvider
          pagination={paginationFactory(pageOptions || [])}
          keyField="id"
          columns={columns(myUser) || []}
          data={entries || []}
        >
          {({ paginationProps, paginationTableProps }) => (
            <ToolkitProvider
              keyField="id"
              data={entries || []}
              columns={columns(myUser) || []}
              remote={{ filter: true }}
              sort={{
                dataField: "id",
                order: "desc",
              }}
              bootstrap4
              search
            >
              {toolkitProps => (
                <React.Fragment>
                  <Row>
                    <Col className="text-start">
                      <div className="w-25 custom-searchbar">
                        <SearchBar
                          {...toolkitProps.searchProps}
                          className="w-100"
                        />
                      </div>
                    </Col>
                    <Col className="d-flex justify-content-end">
                      <Link
                        to="/cps-request-wizard"
                        className="btn btn-primary mb-2 ms-4"
                      >
                        Create CPS Request
                      </Link>
                    </Col>
                  </Row>
                  <div className="table-responsive">
                    <BootstrapTable
                      {...toolkitProps.baseProps}
                      {...paginationTableProps}
                      bordered={false}
                      hover={true}
                      classes={"table align-middle table-nowrap table-check"}
                      headerWrapperClasses={"table-light"}
                      defaultSorted={defaultSorted}
                      ref={node}
                    />
                    {entries?.length == 0 && (
                      <Row className="justify-content-center">
                        <Col xs="12" className="text-center mt-4 mb-4">
                          <p className="mb-0">No CPS requests found.</p>
                        </Col>
                      </Row>
                    )}
                  </div>
                  <Row className="justify-content-md-end">
                    <Col className="pagination pagination-rounded justify-content-end mb-2">
                      <PaginationListStandalone {...paginationProps} />
                    </Col>
                  </Row>
                </React.Fragment>
              )}
            </ToolkitProvider>
          )}
        </PaginationProvider>
      </CardBody>
    </Card>
  )
}

export default CPSRequestsList
